import React from 'react'
function Loading() {
    return (
        <div>
            <h1>Room Data Is Loading</h1>
            <img src='../images/gif/loading-arrow.gif' alt='loading'/>        </div>
    )
}

export default Loading
